module.exports = __webpack_public_path__ + "img/patient-billing-filter.eca12ebb.png";